var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-resize-observer",
    {
      on: {
        resize: function ($event) {
          return _vm.$emit("resize", $event)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "base-virtual-scroll-viewport-item",
          attrs: {
            "data-id": _vm.itemId,
            "data-index": _vm.realIndex,
            "data-component": "grouped-by-contact-session-list-item",
          },
        },
        [
          _c(
            "keep-alive",
            [
              _vm.isActivated
                ? _vm._t("default")
                : _c("div", {
                    staticClass:
                      "base-virtual-scroll-viewport-item-placeholder",
                    style: { height: _vm.itemSize + "px" },
                  }),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }